
window.AWT_PORTAL_FREQUENCY_LABELS = {
    "710894453045": "3 times a year APRIL, SEPTEMBER, NOVEMBER",
    "710463488309": "Delivered twice yearly (FEBRUARY, AUGUST)",
    "710463553845": "Deliver every 1 Month",
    "710463521077": "Deliver every 2 Months",
    "710469517621": "Deliver every 3 Months"
};

(function () {
    var PLAN_LABELS = window.AWT_PORTAL_FREQUENCY_LABELS || {};
    var DETAIL_SELECTOR = '.awt-frequency-container';
    var LIST_ITEM_SELECTOR = '[data-subscription-id]';
    var LIST_LABEL_SELECTOR = '.bundleapp-subscription-list-item__subscription-delivery-frequency';

    function planIdOf(subscription) {
        var lines = (subscription && subscription.Lines) || [];
        for (var i = 0; i < lines.length; i++) {
            var gid = lines[i] && lines[i].SellingPlanId;
            if (gid) return String(gid).split('/').pop();
        }
        return null;
    }

    function labelFor(subscription) {
        var id = planIdOf(subscription);
        return (id && PLAN_LABELS[id]) || null;
    }

    function setText(el, text) {
        if (!el || !text) return;
        var target = el.querySelector('span') || el;
        if (target.textContent.trim() !== text) target.textContent = text;
    }

    function applyDetail() {
        var awtomic = window.Awtomic || {};
        var label = labelFor(awtomic.subscriptionDetails);
        if (label) setText(document.querySelector(DETAIL_SELECTOR), label);
    }

    function applyList() {
        var items = (window.Awtomic || {}).subscriptionList || [];
        if (!items.length) return;
        var byId = {};
        items.forEach(function (item) {
            var id = String(item.SubscriptionId || '').split('/').pop();
            var label = labelFor(item);
            if (id && label) byId[id] = label;
        });
        var rows = document.querySelectorAll(LIST_ITEM_SELECTOR);
        Array.prototype.forEach.call(rows, function (row) {
            var label = byId[row.getAttribute('data-subscription-id')];
            if (label) setText(row.querySelector(LIST_LABEL_SELECTOR), label);
        });
    }

    function apply() {
        try { applyDetail(); applyList(); } catch (e) {}
    }

    var scheduled = false;
    function schedule() {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(function () { scheduled = false; apply(); });
    }

    window.addEventListener('awtomic-cp-loaded', schedule);

    function start() {
        apply();
        new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }

    if (document.body) start();
    else document.addEventListener('DOMContentLoaded', start);
})();
